import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  center?: boolean;
  children: ReactNode;
  right?: boolean;
}

const Footer = ({ center = false, children, right = false }: Props) => {
  const className = classnames({
    'bg-footer-background-color': true,
    'border-t': true,
    'border-footer-border-color': true,
    'text-footer-text-color': true,
    flex: true,
    '!py-2': true,
    'justify-center': center,
    'justify-end': right,
  });

  return <footer className={className}>{children}</footer>;
};

export default Footer;
